export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";